export default function SpeakerLegend() {
  return (
    <div className="flex gap-4 text-sm">
      <div className="flex items-center gap-1.5">
        <span className="w-3 h-3 rounded-full bg-blue-500"></span>
        <span className="text-base-content/70">Physician</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="w-3 h-3 rounded-full bg-amber-500"></span>
        <span className="text-base-content/70">Patient</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="w-3 h-3 rounded-full bg-teal-500"></span>
        <span className="text-base-content/70">Nurse</span>
      </div>
    </div>
  )
}
